import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';

interface AccidentAccidentInProgressDialogProps {
  open: boolean;
  onClose?: () => void;
  onAccept?: () => void;
  onDeny?: () => void;
}

export const AccidentAccidentInProgressDialog = ({
  onDeny,
  onClose,
  onAccept,
  open
}: AccidentAccidentInProgressDialogProps) => {
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle id="alert-dialog-title">Evidujeme nedokončenou nehodu!</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          V rámci systému u vás evidujeme nedokončenou nehodu. Chcete přejít na tuto nehodu nebo začít novou?
        </DialogContentText>
      </DialogContent>
      <DialogActions
        sx={{
          py: 4,
          justifyContent: 'center',
          flexDirection: { xs: 'column-reverse', md: 'row' },
          gap: 2
        }}
      >
        <Button onClick={onDeny}>Zahodit a založit novou</Button>
        <Button autoFocus variant="contained" color="success" onClick={onAccept}>
          Pokračovat ve tvorbě
        </Button>
      </DialogActions>
    </Dialog>
  );
};
